import React from 'react';
import { Text, Flex, Box } from '@chakra-ui/react';
import { useCallback } from 'react';
import { IoExtensionPuzzleOutline } from 'react-icons/io5';
import { useStore } from '../../zustand';
import { FiCheckCircle } from 'react-icons/fi';

const ConfiguredNodeCard = ({ node }) => {
	const onCommandFocus = useStore(
		useCallback((state) => state.onCommandFocus, [])
	);

	const onMissingFieldClick = (selectedNode) => {
		onCommandFocus({
			shouldCenter: true,
			x: selectedNode.data.node.x,
			y: selectedNode.data.node.y,
			zoom: 1.2,
		});
	};

	return (
		<Flex
			justifyContent="space-between"
			backgroundColor="#ffffff"
			minHeight="70px"
			maxHeight="70px"
			alignItems="center"
			border="1px solid #DEDCDC"
			borderRadius="2px"
			padding="1rem"
			marginBottom="10px"
			cursor="pointer"
			onClick={() => onMissingFieldClick(node)}
		>
			<Flex alignItems="center">
				<Flex shrink={1}>
					<IoExtensionPuzzleOutline size="22px" color="#585858" />
				</Flex>
				<Box marginX="10px">
					<Text
						textStyle="sans.sm"
						marginBottom="0 !important"
						noOfLines={1}
					>
						{node.data.node.name
							? `${node.data.node.name}`
							: `${node.data.node.type}`}
					</Text>
					<Text
						color="#939393"
						fontSize={12}
						fontWeight="medium"
						marginBottom="0 !important"
					>
						CONFIGURED NODE
					</Text>
				</Box>
			</Flex>
			<Flex shrink={1}>
				<FiCheckCircle size="16px" color="#3a3a3a" />
			</Flex>
		</Flex>
	);
};

export default ConfiguredNodeCard;
